import VideoPlayer from "./Video";

export default VideoPlayer